export class PalletData {

    static palletImages = [];
    static selectedRoutes = "";
    static selectedOperators = "";
    static selectedWrappers = "";
    static selectedInferences = "";

    static selectedRouteValues = [];
    static selectedOperatorValues = [];
    static selectedWrapperValues = [];
    static selectedInferenceValues = [];

    static isRouteSelected = false
    static isOpratorSelected = false;
    static isWrapperSelected = false;
    static isInferenceSelected = false;
    static imageNotExist = "ImageNotExist";

    static selAllRoutes = [];
    static selAllWrappers = [];
    static selAllSelectors = [];
    static selAllInferences = [];

    static palletStatues = ['VOR Verified','Verified/Needs Confirmation','Error Found','Contains Untrained SKU','System Error']

    static isPalletImageExist = (picklistId,inference_id)=>{
      // if(PalletData.palletImages.indexOf())
        let arr = PalletData.palletImages;
        if(arr.length>0){
            // Compare as strings: the list-pallets backend and the barcode
            // scanner backend can return the same id with different types
            // (e.g. number vs string). String compare lets a scanned pallet
            // reuse the image cached during page load instead of refetching.
            let obj = arr.find(o => String(o.Key) === String(picklistId) && String(o.Inference) === String(inference_id));
            if(obj){
                return obj.Value;
            }
        }
        return null;

    }

    static savePalletImages = (picklistId,imgUrl,inference_id)=>{
        // Avoid stacking duplicate/stale entries for the same pallet (the
        // scan flow remounts cards repeatedly and would otherwise push many
        // records, and a stale "imageNotExist" could shadow a real URL).
        let existing = PalletData.palletImages.find(
            o => String(o.Key) === String(picklistId) && String(o.Inference) === String(inference_id)
        );
        if(existing){
            existing.Value = imgUrl;
            return;
        }
        PalletData.palletImages.push({Key:picklistId,Value:imgUrl,Inference:inference_id});
        //return imgUrl;
    }

}
